// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/.pnpm/css-loader@6.7.1_webpack@5.89.0/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".MainNav-module__mainNav--oPYoF{width:3.125rem;background:var(--xm-color--main-nav-bg);position:relative}.MainNav-module__mainNav--oPYoF.MainNav-module__wideMode--yj6IU{width:9.375rem}.MainNav-module__navContent--HqWam{display:flex;flex-direction:column;justify-content:space-between;width:100%;height:100%;padding:var(--xm-size--main-nav-padding);overflow:auto;overflow-x:hidden}.MainNav-module__mainItems--__r8K{flex-grow:1}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"mainNav": "MainNav-module__mainNav--oPYoF",
	"wideMode": "MainNav-module__wideMode--yj6IU",
	"navContent": "MainNav-module__navContent--HqWam",
	"mainItems": "MainNav-module__mainItems--__r8K"
};
export default ___CSS_LOADER_EXPORT___;
